// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2IuZU","upload":"Small_upload__539ny","imageWrap":"Small_imageWrap__1heN4","removeBtn":"Small_removeBtn__3CR78"};